import type { TFunction } from "i18next";
import { ProductTypeType } from "@/types/graphql/partner.generated";
import type { ProductsItem } from "@/partner/entities/products";
import { getMinPrice } from "./getMinPrice";
import { formatCurrency } from "./formatCurrency";

/**
 * Подпись цены в списке продуктов (референс:
 * partner/utils/getPriceButtonText.js). У нас нет типа DONATION
 * (ProductType = PPV | SUBSCRIPTION), поэтому ветка доната не переносится.
 */
export function getPriceButtonText(
  product: Pick<ProductsItem, "type" | "prices">,
  t: TFunction
): string | null {
  const minPrice = getMinPrice(product);

  if (!minPrice) {
    return null;
  }

  if (product.type === ProductTypeType.SubscriptionType) {
    const value = formatCurrency(minPrice.value, minPrice.currency);

    if (product.prices.length > 1) {
      return t("products.getPriceButtonText.recurrentPrices", { value });
    }

    return t("products.getPriceButtonText.recurrentPrice", { value });
  }

  const periods = product.prices.flatMap((price) => price.periods);
  const min = Math.min(...periods.map((period) => period.value));
  const value = formatCurrency(min, minPrice.currency);

  if (periods.length > 1) {
    return t("products.getPriceButtonText.ppvPrices", { value });
  }

  return t("products.getPriceButtonText.ppvPrice", { value });
}
